import { useState } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import {
  Section,
  LayoutContainer
} from "../../../../components/CustomLayout/CustomLayoutStyles";
import TittleLine from "../../../../components/Common/TittleLine";
import CheckRender from "../../../../components/Common/CheckRender";
import CustomAlert from "../../../../components/Common/CustomAlert";
import { useUpdateEffect, useMountEffect } from "../../../../hooks/LifeCycle";
import ModalLoader from "../../../../components/Common/ModalLoader";
import CustomButton from "../../../../components/CustomButton/CustomButton";
import Colors from "../../../../themes/Colors";
import { useHistory } from "react-router-dom";
import standVirtualRoutes from "../../standVirtualRoutes";
import CustomTable from "../../../../components/CustomTable/CustomTable";
import Tooltip from "../../../../components/Common/Tooltip";
import CustomIcon from "../../../../components/Common/CustomIcon";
import { DownloadOutlined } from "@ant-design/icons";
import Titulo from "../../shared/Titulo";
import moment from "moment";
import CustomMainNavBar from "../../../../components/CustomHeader/CustomMainNavBar";
import { MainContent } from "../../styles/MainLayoutStandVirtualStyles";

import precertificacionService from "../../../../services/precertificacion/PrecertificacionService";

import precertificacionTypes from "../../../../stores/precertificacion/Actions";
import PrecertificacionGenerales from "../components/PrecertificacionGenerales";
import PrecertificacionDatosAfiliado from "../components/PrecertificacionDatosAfiliado";
import { ESTADOS_PRECERTIFICACION } from "../../constantes";

const PrecertificacionVerScreen = (props) => {
  const history = useHistory();
  const { id } = useParams();
  const [precertificacion, setPrecertificacion] = useState();
  const [alertConfig, setAlertConfig] = useState({});
  const [showAlert, setShowAlert] = useState(false);
  const goTo = (path) => {
    history.push(path);
  };

  const mostrarAlerta = (mensaje, tipo = "info", titulo = "¡Hola!") => {
    setAlertConfig({
      type: tipo,
      title: titulo,
      message: mensaje,
      onConfirm: () => {
        setShowAlert(false);
        handleMisSolicitudes();
      }
    });
    setShowAlert(true);
  };

  const mostrarError = (mensaje) => {
    mostrarAlerta(mensaje, "error", "¡Error!");
  };

  const handleMisSolicitudes = () => {
    const createNewRequest = `/${standVirtualRoutes.base.route}/${standVirtualRoutes.precertificacion.route}`;
    goTo(createNewRequest);
  };

  const handleModificar = () => {
    const createNewRequest = `/${
      standVirtualRoutes.base.route
    }/${standVirtualRoutes.precertificacionModificar.route.replace(
      ":id",
      precertificacion.id
    )}/`;
    goTo({
      pathname: createNewRequest,
      state: { precertificacion }
    });
  };

  const handleDescargarAdjunto = async (id, nombreArchivo) => {
    try {
      const response =
        await precertificacionService.descargarAdjuntoPrecertificacion({
          id,
          nombreArchivo
        });

      const blob = new Blob([response]);
      const link = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = link;
      a.download = nombreArchivo;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(link);
    } catch (error) {
      console.error("Descarga fallida:", error);
      mostrarError("Error al descargar el archivo adjunto.");
    }
  };

  const columnasCobeturas = [
    {
      title: "Procedimientos",
      dataIndex: "nombreCobertura",
      key: "nombreCobertura"
    }
  ];

  const columnasArchivos = [
    {
      title: "Archivos",
      dataIndex: "filename",
      key: "filename"
    },
    {
      title: "Acciones",
      dataIndex: "acciones",
      key: "acciones",
      render: (_, record) => (
        <Tooltip text={`Descargar ${record.filename}`} position="top">
          <CustomIcon
            icon={DownloadOutlined}
            style={{
              fontSize: "20px",
              color: Colors.primaryPrimera,
              cursor: "pointer",
              padding: "8px",
              borderRadius: "4px",
              transition: "all 0.3s ease"
            }}
            hoverColor={Colors.darkGreenPrimera}
            onClick={() => handleDescargarAdjunto(record.id, record.filename)}
          />
        </Tooltip>
      )
    }
  ];

  const columnasMensajes = [
    {
      title: "Mensajes",
      dataIndex: "comentario",
      key: "comentario"
    },
    {
      title: "fecha",
      dataIndex: "fecha",
      key: "fecha",
      render: (text) => moment(text).format("DD/MM/YYYY")
    }
  ];

  //Mostrar alerta de error
  useUpdateEffect(() => {
    if (props.consultarUnaPrecertificacionError) {
      const { mensaje } = props.consultarUnaPrecertificacionError;
      mostrarError(mensaje);
    }
  }, [props.consultarUnaPrecertificacionError]);

  useMountEffect(() => {
    props.consultarUnaPrecertificacion({ id });
  });

  useUpdateEffect(() => {
    if (
      !props.consultarUnaPrecertificacionData ||
      !props.consultarUnaPrecertificacionData?.precertificacion
    )
      return;

    const { precertificacion } = props.consultarUnaPrecertificacionData;
    setPrecertificacion(precertificacion);
  }, [props.consultarUnaPrecertificacionData]);

  useUpdateEffect(() => {
    setShowAlert(false);
    setAlertConfig({});
  }, []);

  return (
    <LayoutContainer>
      <CustomMainNavBar />
      <MainContent>
        <CheckRender allowed={precertificacion}>
          <Section>
            <TittleLine
              title={`Pre-Certificación ${precertificacion?.numeroSolicitud} | Estado ${precertificacion?.estado}`}
              customButton={
                <CustomButton
                  label="Mis Solicitudes"
                  bgColor={Colors.darkGreenPrimera}
                  hoverColor={Colors.LightGreenPrimera}
                  textColor={Colors.white}
                  hoverTextColor={Colors.white}
                  onClick={handleMisSolicitudes}
                  width="200px"
                  fontSize="16px"
                />
              }
            />
          </Section>

          <PrecertificacionDatosAfiliado
            afiliado={{
              nombre: precertificacion?.nombreAsegurado,
              cedula: precertificacion?.cedula,
              numeroPlastico: precertificacion?.numeroPlastico,
              plan: precertificacion?.descripcionPlan
            }}
          />
          <PrecertificacionGenerales precertificacion={precertificacion} />

          <Titulo titulo={"PROCEDIMIENTOS"} />
          <CustomTable
            columns={columnasCobeturas}
            dataSource={precertificacion?.detalle}
            showPagination={false}
            pageSize={10}
            width={"95%"}
            minHeight={"150px"}
            maxHeight={"400px"}
          />

          <Titulo titulo={"ADJUNTOS"} />
          <CustomTable
            columns={columnasArchivos}
            dataSource={precertificacion?.archivos}
            showPagination={false}
            pageSize={10}
            width={"95%"}
            minHeight={"150px"}
            maxHeight={"400px"}
          />

          <CheckRender allowed={precertificacion?.mensajes?.length > 0}>
            <Titulo titulo={"MENSAJES"} />
            <CustomTable
              columns={columnasMensajes}
              dataSource={precertificacion?.mensajes}
              showPagination={false}
              pageSize={10}
              width={"95%"}
              minHeight={"150px"}
              maxHeight={"400px"}
            />
          </CheckRender>

          <CheckRender
            allowed={
              precertificacion?.estado ===
                ESTADOS_PRECERTIFICACION.ABIERTA.texto ||
              precertificacion?.estado ===
                ESTADOS_PRECERTIFICACION.DEVUELTA.texto
            }
          >
            <Section gap={"10px"} marginTop={"20px"}>
              <CustomButton
                label={"Modificar Solicitud"}
                width={"200px"}
                onClick={handleModificar}
                isLoading={props.crearCertificacionLoading}
              />
            </Section>
          </CheckRender>
        </CheckRender>

        <CheckRender allowed={showAlert}>
          <CustomAlert {...alertConfig} />
        </CheckRender>

        <CheckRender allowed={props.consultarUnaPrecertificacionLoading}>
          <ModalLoader />
        </CheckRender>
      </MainContent>
    </LayoutContainer>
  );
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  consultarUnaPrecertificacionLoading:
    state.precertificacion.consultarUnaPrecertificacionLoading,
  consultarUnaPrecertificacionError:
    state.precertificacion.consultarUnaPrecertificacionError,
  consultarUnaPrecertificacionData:
    state.precertificacion.consultarUnaPrecertificacionData
});

const mapDispatchToProps = {
  consultarUnaPrecertificacion:
    precertificacionTypes.consultarUnaPrecertificacion
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(PrecertificacionVerScreen);
